export default __webpack_public_path__ + "assets/audios/3f4f7920c91a341e7aa5b8e8e666d00a.mp3";